import GetLoading from "../../share/getLoading";
// // InformationDeptPage.js
// import { useEffect, useState } from "react";
// import Table from "react-bootstrap/Table";
// import { request } from "../../share/request";
// import { Stack } from "react-bootstrap";
// import {
//   PlusCircleOutlined,
//   CheckCircleOutlined,
//   ClockCircleOutlined,
//   EditFilled,
//   DeleteFilled,
//   UserOutlined,
// } from "@ant-design/icons";
// import {
//   Modal,
//   Button,
//   Form,
//   Input,
//   Select,
//   Space,
//   Tag,
//   Checkbox,
//   Pagination,
//   InputNumber,
//   Row,
//   Col,
//   message,
//   Avatar,
//   Tooltip,
// } from "antd";
// import "../../styles/Home-module.css";
// import { openNotification } from "../../share/message";

// import { getCurrentUser, getPermission } from "../../share/getProfile";
// import { getTageStyle } from "../../share/getStatusContent";
// import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
// import DeleteDepartmentModal from "../../component/DeleteModal/DeleteDepartmentModal";
// import { linkPath } from "../../share/helper";

// const { Option } = Select;

// // Font styles
// const khmerFont = {
//   fontFamily: "'Content', system-ui, sans-serif",
// };

// const englishFont = {
//   fontFamily: "'Poppins-SemiBold', 'Poppins', 'Poppins SemiBold', system-ui, sans-serif",
// };

// const mixedFont = {
//   fontFamily: "'Poppins-SemiBold', 'Content', system-ui, sans-serif",
// };

// const InformationDeptPage = () => {
//   const getProfileOrg = getCurrentUser();
//   const [Total, setTotalCount] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [list, setList] = useState([]);
//   const [listdepart, setListDepart] = useState([]);
//   const [visableNewDepartment, setVisableNewDepartment] = useState(false);
//   const [visableTextbox, setVisableTextbox] = useState(false);
//   const [code, setCode] = useState("");
//   const [department, setDepartment] = useState("");
//   const [department_en, setDepartment_EN] = useState("");
//   const [des, setDes] = useState("");
//   const [other, setOther] = useState("");
//   const [level_number, setLevel_number] = useState("");
//   const [under_dept_id, setUnderDepartment_id] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [loadingSpin, setLoadingSpin] = useState(false);
//   const [enable, setEnable] = useState(false);
//   const [disable, setDisable] = useState(true);
//   const [pageNumber, setPageNumber] = useState(1);

//   // Delete modal state
//   const [deleteModalVisible, setDeleteModalVisible] = useState(false);
//   const [deleteDepartmentData, setDeleteDepartmentData] = useState({
//     departmentName: "",
//     departmentCode: "",
//     departmentId: "",
//     parentDept: "",
//   });

//   const [objFilter, setObjFilter] = useState({
//     page: 1,
//     department_name: "",
//     org_code: getProfileOrg?.org_code || 1,
//   });

//   // permissions
//   const userPermission = getPermission();
//   const deapartmentValue = userPermission.find(
//     (permission) => permission.pagename === "department"
//   ) || { add: 0, edit: 0, deleted: 0 };
//   const { add: addvalue, edit: Editvalue, deleted: deletevalue } = deapartmentValue;

//   // initial load
//   useEffect(() => {
//     getList(objFilter);
//     getListAllDepartments(objFilter);
//   }, []);

//   const getList = async (filter) => {
//     const param = new URLSearchParams({
//       page: filter.page || 1,
//       department_name: filter.department_name || "",
//       org_code: filter.org_code || 1,
//     });
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       const res = await request("department?" + param.toString(), "get", {});
//       if (res) {
//         setList(res.listdepartment || []);
//         setTotalCount(res.total_records || 0);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getListAllDepartments = async (filter) => {
//     const param = new URLSearchParams({
//       department_name: filter.department_name || "",
//       org_code: filter.org_code || 1,
//     });
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       const res = await request("departmentall?" + param.toString(), "get", {});
//       if (res) {
//         setListDepart(res.listdepartment || []);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const getListDept = async (filter) => {
//     const param = new URLSearchParams({
//       page: filter.page || 1,
//       department_name: filter.department_name || "",
//       org_code: filter.org_code || 1,
//     });
//     try {
//       const res = await request("department?" + param.toString(), "get", {});
//       if (res) {
//         setListDepart(res.listdepartment || []);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   // pagination
//   const itemsPerPage = 10;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

//   const onOpenNewDepartment = () => {
//     setVisableTextbox(true);
//     setVisableNewDepartment(true);
//     setCode("");
//     setDepartment("");
//     setDepartment_EN("");
//     setDes("");
//     setOther("");
//     setLevel_number("");
//     setUnderDepartment_id("");
//     setEnable(false);
//     setDisable(true);
//   };

//   const onOpenModelDelete = (item) => {
//     setDeleteDepartmentData({
//       departmentName: item.department_name,
//       departmentCode: item.code,
//       departmentId: item.id || item.code,
//       parentDept: item.parent_dept || "",
//     });
//     setDeleteModalVisible(true);
//   };

//   const onClickDeleteYes = async () => {
//     const { departmentCode } = deleteDepartmentData;
//     console.log("Deleting department with code:", departmentCode);
    
//     if (!departmentCode) {
//       message.error("Department code not found");
//       return;
//     }
    
//     try {
//       const res = await request("department/" + departmentCode, "delete", {});
//       if (res.success === true) {
//         getList(objFilter);
//         openNotification("success", "Success", "Department deleted successfully");
//         setDeleteModalVisible(false);
//       } else {
//         message.error(res?.message || "Error deleting department");
//       }
//     } catch (error) {
//       console.error("Delete error:", error);
//       message.error("Failed to delete department");
//     }
//   };

//   const onCloseDepartment = () => setVisableNewDepartment(false);
//   const onCancel = () => setVisableNewDepartment(false);

//   const onChangeCode = (e) => setCode(e.target.value);
//   const onChangeDeparment = (e) => setDepartment(e.target.value);
//   const onChangeDeparment_en = (e) => setDepartment_EN(e.target.value);
//   const onChageDes = (e) => setDes(e.target.value);
//   const onChangeOther = (e) => setOther(e.target.value);
//   const onChangeLevel_number = (e) => setLevel_number(e);

//   const handleCheckboxChange_Enable = (e) => {
//     setEnable(e.target.checked);
//     setDisable(false);
//   };
//   const handleCheckboxChange_Diable = (e) => {
//     setDisable(e.target.checked);
//     setEnable(false);
//   };

//   const onSaveDepartment = async () => {
//     const data = {
//       code: code,
//       department_name: department,
//       department_en: department_en,
//       department_des: des,
//       other: other,
//       status: enable ? 1 : 0,
//       org_code: getProfileOrg?.org_code,
//       under_dept_id: under_dept_id,
//       level_number: level_number,
//     };

//     try {
//       const method = !code ? "post" : "put";
//       const res = await request("department", method, data);
//       setVisableNewDepartment(false);
//       if (res && res.success) {
//         getList(objFilter);
//         openNotification("success", "Success", res.message || (method === "post" ? "Created" : "Updated"));
//       } else {
//         openNotification("error", "Error", res?.message || "Something went wrong");
//       }
//     } catch (error) {
//       openNotification("error", "Error", "Something went wrong");
//     }
//   };

//   const onOpenEditModel = (item) => {
//     setVisableTextbox(true);
//     setVisableNewDepartment(true);
//     setUnderDepartment_id(item.parent_id);
//     setLevel_number(item.level_no);
//     setCode(item.code);
//     setDepartment(item.department_name);
//     setDepartment_EN(item.department_en);
//     setDes(item.department_des);
//     setOther(item.other);
//     if (item.status === 1) {
//       setEnable(true);
//       setDisable(false);
//     } else {
//       setEnable(false);
//       setDisable(true);
//     }
//   };

//   const getStatusContent = (status) => {
//     switch (status) {
//       case 1:
//         return (
//           <Button type="primary" ghost shape="round" icon={<CheckCircleOutlined />} style={mixedFont}>
//             Enable
//           </Button>
//         );
//       case 0:
//         return (
//           <Button type="primary" danger ghost shape="round" icon={<ClockCircleOutlined />} style={mixedFont}>
//             Disable
//           </Button>
//         );
//       default:
//         return null;
//     }
//   };

//   const onShowSizeChange = async (current) => {
//     setPageNumber(current);
//     const objTmp = { ...objFilter, page: current };
//     setObjFilter(objTmp);
//     await getList(objTmp);
//   };

//   const OnSearchText = (value) => {
//     setCurrentPage(1);
//     const objTmp = {
//       ...objFilter,
//       department_name: value.target.value,
//       page: 1,
//     };
//     setObjFilter(objTmp);
//     getList(objTmp);
//   };

//   const OnSearchTextDept = (value) => {
//     const objTmp = {
//       ...objFilter,
//       department_name: value.target.value,
//       page: 1,
//     };
//     getListDept(objTmp);
//   };

//   return (
//     <div style={khmerFont}>
//       <div className="sprinSave-container">
//         {loadingSpin && (
//           <div className="sprinSave">
//             <GetLoading />
//           </div>
//         )}
//       </div>

//       <div style={boxHeader}>
//         <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
//           {boxHeaderTagText("ការគ្រប់គ្រង់ ព័ត៌មានផ្នែក")}
//           <Input style={{ width: 250, ...mixedFont }} placeholder="ស្វែងរក..." onChange={OnSearchText} allowClear />
//         </div>
//         <div>
//           <Button disabled={!addvalue} onClick={onOpenNewDepartment} type="primary" icon={<PlusCircleOutlined />} style={mixedFont}>
//             បន្ថែមផ្នែកថ្មី
//           </Button>
//         </div>
//       </div>

//       <div>
//         {loading ? (
//           <div className="sprinCustome">
//             <GetLoading />
//           </div>
//         ) : (
//           <Table className="rounded-table">
//             <thead>
//               <tr className="table-success">
//                 <th style={khmerFont}>#</th>
//                 <th style={khmerFont}>លេខកូដ</th>
//                 <th style={khmerFont}>ផ្នែក (ខ្មែរ)</th>
//                 <th style={englishFont}>Department (English)</th>
//                 <th style={khmerFont}>ស្ថិតក្រោម</th>
//                 <th style={khmerFont}>កំរិត</th>
//                 <th style={mixedFont}>ស្ថានភាព / Status</th>
//                 <th style={khmerFont}>សកម្មភាព</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.map((item, idx) => (
//                 <tr key={item.code || idx}>
//                   <td style={khmerFont}>{itemsPerPage * (pageNumber - 1) + idx + 1}</td>
//                   <td style={khmerFont}>{getTageStyle("CODE:" + item.code)}</td>
//                   <td style={khmerFont}><strong>{item.department_name}</strong>
//                    <div style={styles.staffContainer}>
//   {item.staff_list && item.staff_list.map((staff, index) => (
//     <Tooltip key={index} title={`${staff.fullname || staff.username}${staff.rank_short ? ` (${staff.rank_short})` : ''}`}>
//       <div style={styles.avatarWrapper}>
//         <Avatar 
//           src={staff.image ? `${linkPath}${staff.image}` : null}
//           icon={!staff.image && <UserOutlined />}
//           style={styles.staffAvatar}
//           size="medium"
//         >
//           {!staff.image && staff.fullname ? staff.fullname.charAt(0).toUpperCase() : null}
//         </Avatar>
       
//           <span style={styles.onlineDot}></span>
      
//       </div>
//     </Tooltip>
//   ))}
// </div>
//                   </td>
//                   <td style={englishFont}>{item.department_en}
                   
//                   </td>
//                   <td style={khmerFont}>{item.parent_dept && <Tag color="magenta" style={khmerFont}>{item.parent_dept}</Tag>}</td>
//                   <td style={khmerFont}>{item.level_no}</td>
//                   <td style={mixedFont}>{getStatusContent(item.status)}</td>
//                   <td style={{ width: 100 }}>
//                     <Stack gap={1} direction="horizontal">
//                       <Button type="primary" icon={<EditFilled />} disabled={!Editvalue} onClick={() => onOpenEditModel(item)} />
//                       <Button icon={<DeleteFilled />} disabled={!deletevalue} onClick={() => onOpenModelDelete(item)} danger />
//                     </Stack>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         )}
//         <Pagination onChange={onShowSizeChange} defaultCurrent={currentPage} total={Total} style={{ marginTop: 16, textAlign: "center" }} />
//       </div>

//       {/* Add/Edit Modal */}
//       <Modal
//         title={!code ? "បង្កើតផ្នែកថ្មី" : "កែប្រែផ្នែក"}
//         width={700}
//         open={visableNewDepartment}
//         onCancel={onCancel}
//         footer={[
//           <Button key="cancel" danger onClick={onCloseDepartment} style={mixedFont}>Cancel</Button>,
//           <Button key="save" type="primary" onClick={onSaveDepartment} style={mixedFont}>{!code ? "Save" : "Update"}</Button>,
//         ]}
//       >
//         <Row gutter={16}>
//           <Col span={12}>
//             <Form.Item label={<span style={khmerFont}>លេខកូដផ្នែក</span>}>
//               <Input value={code} onChange={onChangeCode} disabled={visableTextbox} style={khmerFont} />
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>ឈ្មោះផ្នែក / ភាសាខ្មែរ</span>}>
//               <Input.TextArea rows={2} value={department} onChange={onChangeDeparment} style={khmerFont} />
//             </Form.Item>
//             <Form.Item label={<span style={englishFont}>Department Name / English</span>}>
//               <Input.TextArea rows={2} value={department_en} onChange={onChangeDeparment_en} style={englishFont} />
//             </Form.Item>
//             <Form.Item label={<span style={mixedFont}>ស្ថានភាព / Status</span>}>
//               <Space>
//                 <Checkbox checked={enable} onChange={handleCheckboxChange_Enable} style={mixedFont}>Enable</Checkbox>
//                 <Checkbox checked={disable} onChange={handleCheckboxChange_Diable} style={mixedFont}>Disable</Checkbox>
//               </Space>
//             </Form.Item>
//           </Col>
//           <Col span={12}>
//             <Form.Item label={<span style={khmerFont}>ស្ថិតក្រោម</span>}>
//               <Select
//                 showSearch allowClear placeholder="Select department"
//                 value={under_dept_id}
//                 onSearch={(val) => OnSearchTextDept({ target: { value: val } })}
//                 onChange={setUnderDepartment_id}
//                 style={khmerFont}
//               >
//                 {listdepart.map(opt => (
//                   <Option key={opt.code} value={opt.code} style={khmerFont}>{opt.department_name}</Option>
//                 ))}
//               </Select>
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>កំរិត</span>}>
//               <InputNumber min={1} max={10} value={level_number} onChange={onChangeLevel_number} style={{ width: "100%" }} />
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>បរិយាយ</span>}>
//               <Input.TextArea rows={3} value={des} onChange={onChageDes} style={khmerFont} />
//             </Form.Item>
//             <Form.Item label={<span style={khmerFont}>ផ្សេងៗ</span>}>
//               <Input.TextArea rows={2} value={other} onChange={onChangeOther} style={khmerFont} />
//             </Form.Item>
//           </Col>
//         </Row>
//       </Modal>

//       {/* Delete Department Modal */}
//       <DeleteDepartmentModal
//         visible={deleteModalVisible}
//         onCancel={() => setDeleteModalVisible(false)}
//         onConfirm={onClickDeleteYes}
//         departmentName={deleteDepartmentData.departmentName}
//         departmentCode={deleteDepartmentData.departmentCode}
//         departmentId={deleteDepartmentData.departmentId}
//         parentDept={deleteDepartmentData.parentDept}
//         loading={loadingSpin}
//       />
//     </div>
//   );
// };
// const styles = {
//   container: {
//     padding: "20px",
//     background: "#f5f5f5",
//     minHeight: "calc(100vh - 200px)",
//   },
//   header: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: 20,
//     padding: "0 8px",
//     flexWrap: "wrap",
//     gap: 12,
//   },
//   headerTitle: {
//     display: "flex",
//     alignItems: "center",
//     gap: 16,
//     flexWrap: "wrap",
//   },
//   stats: {
//     display: "flex",
//     gap: 8,
//     alignItems: "center",
//   },
//   treeCard: {
//     borderRadius: 12,
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//   },
//   treeContainer: {
//     padding: "16px",
//     maxHeight: "calc(100vh - 350px)",
//     overflowY: "auto",
//   },
//   tree: {
//     background: "transparent",
//   },
//   treeNodeTitle: {
//     display: "flex",
//     alignItems: "center",
//     gap: 12,
//     flexWrap: "wrap",
//     padding: "8px 0",
//     width: "100%",
//     borderBottom: "1px solid #f0f0f0",
//   },
//   treeNodeIcon: {
//     width: 32,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   treeNodeInfo: {
//     flex: 1,
//     minWidth: 200,
//   },
//   treeNodeName: {
//     display: "flex",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: 8,
//   },
//   treeNodeEn: {
//     fontSize: 12,
//     color: "#666",
//   },
//   treeNodeMeta: {
//     display: "flex",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: 6,
//     marginTop: 4,
//   },
//   metaTag: {
//     fontSize: 10,
//     margin: 0,
//     padding: "0 6px",
//     height: "auto",
//     lineHeight: "18px",
//   },
//   treeNodeActions: {
//     display: "flex",
//     gap: 4,
//     flexShrink: 0,
//   },
//   dotGreen: {
//     width: 12,
//     height: 12,
//     borderRadius: 12,
//     background: "#28a745",
//     boxShadow: "0 0 6px rgba(40,167,69,0.7)",
//     marginRight: 6,
//   },
//   dotYellow: {
//     width: 12,
//     height: 12,
//     borderRadius: 12,
//     background: "#f0ad4e",
//     boxShadow: "0 0 6px rgba(240,173,78,0.8)",
//     marginRight: 6,
//   },
//   dotGray: {
//     width: 8,
//     height: 8,
//     borderRadius: 8,
//     background: "#9e9e9e",
//     marginRight: 8,
//   },
//   loadingContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "400px",
//   },
//   modalContent: {
//     padding: "8px 0",
//   },
//   formGroup: {
//     marginBottom: 16,
//   },
//   staffContainer: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     flexWrap: "wrap",
//   },
//   staffAvatar: {
//     border: "2px solid #fff",
//     boxShadow: "0 0 4px rgba(0,0,0,0.2)",
//     backgroundColor: "#1890ff",
//   },
//   avatarWrapper: {
//     position: "relative",
//     display: "inline-block",
//   },
//   onlineDot: {
//     position: "absolute",
//     bottom: 0,
//     right: 0,
//     width: 10,
//     height: 10,
//     borderRadius: "50%",
//     backgroundColor: "#52c41a",
//     border: "2px solid #fff",
//     zIndex: 1,
//   },
//   offlineDot: {
//     position: "absolute",
//     bottom: 0,
//     right: 0,
//     width: 10,
//     height: 10,
//     borderRadius: "50%",
//     backgroundColor: "#d9d9d9",
//     border: "2px solid #fff",
//     zIndex: 1,
//   },
// };
// export default InformationDeptPage;


// InformationDeptPage.js
import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { request } from "../../share/request";
import { Stack } from "react-bootstrap";
import {
  PlusCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  EditFilled,
  DeleteFilled,
  UserOutlined,
} from "@ant-design/icons";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Space,
  Tag,
  Checkbox,
  Pagination,
  InputNumber,
  Row,
  Col,
  message,
  Avatar,
  Tooltip,
} from "antd";
import "../../styles/Home-module.css";
import "./MyDepartment.css";
import { openNotification } from "../../share/message";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import { getTageStyle } from "../../share/getStatusContent";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
import DeleteDepartmentModal from "../../component/DeleteModal/DeleteDepartmentModal";
import { linkPath } from "../../share/helper";

const { Option } = Select;

// Font styles
const khmerFont = {
  fontFamily: "'Content', system-ui, sans-serif",
};

const englishFont = {
  fontFamily: "'Poppins-SemiBold', 'Poppins', 'Poppins SemiBold', system-ui, sans-serif",
};

const mixedFont = {
  fontFamily: "'Poppins-SemiBold', 'Content', system-ui, sans-serif",
};

const InformationDeptPage = () => {
  const getProfileOrg = getCurrentUser();
  const [Total, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [list, setList] = useState([]);
  const [listdepart, setListDepart] = useState([]);
  const [visableNewDepartment, setVisableNewDepartment] = useState(false);
  const [visableTextbox, setVisableTextbox] = useState(false);
  const [code, setCode] = useState("");
  const [department, setDepartment] = useState("");
  const [department_en, setDepartment_EN] = useState("");
  const [des, setDes] = useState("");
  const [other, setOther] = useState("");
  const [level_number, setLevel_number] = useState("");
  const [under_dept_id, setUnderDepartment_id] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [enable, setEnable] = useState(false);
  const [disable, setDisable] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);

  // Delete modal state
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteDepartmentData, setDeleteDepartmentData] = useState({
    departmentName: "",
    departmentCode: "",
    departmentId: "",
    parentDept: "",
    staffList: [],
    childDepartments: [],
  });

  const [objFilter, setObjFilter] = useState({
    page: 1,
    department_name: "",
    org_code: getProfileOrg?.org_code || 1,
  });

  // permissions
  const userPermission = getPermission();
  const deapartmentValue = userPermission.find(
    (permission) => permission.pagename === "department"
  ) || { add: 0, edit: 0, deleted: 0 };
  const { add: addvalue, edit: Editvalue, deleted: deletevalue } = deapartmentValue;

  // initial load
  useEffect(() => {
    getList(objFilter);
    getListAllDepartments(objFilter);
  }, []);

  const getList = async (filter) => {
    const param = new URLSearchParams({
      page: filter.page || 1,
      department_name: filter.department_name || "",
      org_code: filter.org_code || 1,
    });
    try {
      await new Promise((resolve) => setTimeout(resolve, 400));
      const res = await request("department?" + param.toString(), "get", {});
      if (res) {
        setList(res.listdepartment || []);
        setTotalCount(res.total_records || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getListAllDepartments = async (filter) => {
    const param = new URLSearchParams({
      department_name: filter.department_name || "",
      org_code: filter.org_code || 1,
    });
    try {
      await new Promise((resolve) => setTimeout(resolve, 400));
      const res = await request("departmentall?" + param.toString(), "get", {});
      if (res) {
        setListDepart(res.listdepartment || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getListDept = async (filter) => {
    const param = new URLSearchParams({
      page: filter.page || 1,
      department_name: filter.department_name || "",
      org_code: filter.org_code || 1,
    });
    try {
      const res = await request("department?" + param.toString(), "get", {});
      if (res) {
        setListDepart(res.listdepartment || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // pagination
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

  const onOpenNewDepartment = () => {
    setVisableTextbox(true);
    setVisableNewDepartment(true);
    setCode("");
    setDepartment("");
    setDepartment_EN("");
    setDes("");
    setOther("");
    setLevel_number("");
    setUnderDepartment_id("");
    setEnable(false);
    setDisable(true);
  };

  // Check if department can be deleted
  const canDeleteDepartment = (item) => {
    // Check for staff
    const hasStaff = item.staff_list && item.staff_list.length > 0;
    
    // Check for child departments
    const hasChildren = listdepart.some(d => String(d.parent_id) === String(item.code));
    const childDepartments = listdepart.filter(d => String(d.parent_id) === String(item.code));
    
    return { 
      canDelete: !hasStaff && !hasChildren,
      hasStaff, 
      hasChildren,
      staffList: item.staff_list || [],
      childDepartments 
    };
  };

  const onOpenModelDelete = (item) => {
    const { canDelete, hasStaff, hasChildren, staffList, childDepartments } = canDeleteDepartment(item);
    
    if (!canDelete) {
      let errorMessage = "";
      let errorDetails = null;
      
      if (hasStaff && hasChildren) {
        errorMessage = `This department has ${staffList.length} staff member(s) and ${childDepartments.length} sub-department(s). Please remove all staff and sub-departments before deleting.`;
        errorDetails = (
          <div>
            <div style={{ marginBottom: 12 }}>
              <strong>Staff in this department ({staffList.length}):</strong>
              <ul style={{ marginTop: 8 }}>
                {staffList.slice(0, 5).map((staff, idx) => (
                  <li key={idx}>{staff.fullname || staff.username}</li>
                ))}
                {staffList.length > 5 && <li>... and {staffList.length - 5} more</li>}
              </ul>
            </div>
            <div>
              <strong>Sub-departments ({childDepartments.length}):</strong>
              <ul style={{ marginTop: 8 }}>
                {childDepartments.slice(0, 5).map((child, idx) => (
                  <li key={idx}>{child.department_name} ({child.code})</li>
                ))}
                {childDepartments.length > 5 && <li>... and {childDepartments.length - 5} more</li>}
              </ul>
            </div>
          </div>
        );
      } else if (hasStaff) {
        errorMessage = `This department has ${staffList.length} staff member(s). Please reassign or remove all staff before deleting this department.`;
        errorDetails = (
          <div>
            <strong>Staff in this department:</strong>
            <ul style={{ marginTop: 8 }}>
              {staffList.slice(0, 5).map((staff, idx) => (
                <li key={idx}>{staff.fullname || staff.username}</li>
              ))}
              {staffList.length > 5 && <li>... and {staffList.length - 5} more</li>}
            </ul>
          </div>
        );
      } else if (hasChildren) {
        errorMessage = `This department has ${childDepartments.length} sub-department(s). Please delete or reassign all sub-departments before deleting this department.`;
        errorDetails = (
          <div>
            <strong>Sub-departments:</strong>
            <ul style={{ marginTop: 8 }}>
              {childDepartments.slice(0, 5).map((child, idx) => (
                <li key={idx}>{child.department_name} ({child.code})</li>
              ))}
              {childDepartments.length > 5 && <li>... and {childDepartments.length - 5} more</li>}
            </ul>
          </div>
        );
      }
      
      Modal.warning({
        title: "Cannot Delete Department",
        content: (
          <div>
            <p style={{ color: "#ff4d4f" }}>{errorMessage}</p>
            {errorDetails}
          </div>
        ),
        okText: "OK",
        width: 500,
      });
      return;
    }
    
    // Can delete - open confirmation modal
    setDeleteDepartmentData({
      departmentName: item.department_name,
      departmentCode: item.code,
      departmentId: item.id || item.code,
      parentDept: item.parent_dept || "",
      staffList: item.staff_list || [],
      childDepartments: [],
    });
    setDeleteModalVisible(true);
  };

  const onClickDeleteYes = async () => {
    const { departmentCode } = deleteDepartmentData;
    console.log("Deleting department with code:", departmentCode);
    
    if (!departmentCode) {
      message.error("Department code not found");
      return;
    }
    
    setLoadingSpin(true);
    try {
      const res = await request("department/" + departmentCode, "delete", {});
      if (res.success === true) {
        await getList(objFilter);
        await getListAllDepartments(objFilter);
        openNotification("success", "Success", "Department deleted successfully");
        setDeleteModalVisible(false);
      } else {
        message.error(res?.message || "Error deleting department");
      }
    } catch (error) {
      console.error("Delete error:", error);
      message.error(error.response?.data?.message || "Failed to delete department");
    } finally {
      setLoadingSpin(false);
    }
  };

  const onCloseDepartment = () => setVisableNewDepartment(false);
  const onCancel = () => setVisableNewDepartment(false);

  const onChangeCode = (e) => setCode(e.target.value);
  const onChangeDeparment = (e) => setDepartment(e.target.value);
  const onChangeDeparment_en = (e) => setDepartment_EN(e.target.value);
  const onChageDes = (e) => setDes(e.target.value);
  const onChangeOther = (e) => setOther(e.target.value);
  const onChangeLevel_number = (e) => setLevel_number(e);

  const handleCheckboxChange_Enable = (e) => {
    setEnable(e.target.checked);
    setDisable(false);
  };
  const handleCheckboxChange_Diable = (e) => {
    setDisable(e.target.checked);
    setEnable(false);
  };

  const onSaveDepartment = async () => {
    const data = {
      code: code,
      department_name: department,
      department_en: department_en,
      department_des: des,
      other: other,
      status: enable ? 1 : 0,
      org_code: getProfileOrg?.org_code,
      parent_id: under_dept_id,
      level_no: level_number,
    };

    setLoadingSpin(true);
    try {
      const method = !code ? "post" : "put";
      const res = await request("department", method, data);
      setVisableNewDepartment(false);
      if (res && res.success) {
        await getList(objFilter);
        await getListAllDepartments(objFilter);
        openNotification("success", "Success", res.message || (method === "post" ? "Created" : "Updated"));
      } else {
        openNotification("error", "Error", res?.message || "Something went wrong");
      }
    } catch (error) {
      openNotification("error", "Error", "Something went wrong");
    } finally {
      setLoadingSpin(false);
    }
  };

  const onOpenEditModel = (item) => {
    setVisableTextbox(true);
    setVisableNewDepartment(true);
    setUnderDepartment_id(item.parent_id);
    setLevel_number(item.level_no);
    setCode(item.code);
    setDepartment(item.department_name);
    setDepartment_EN(item.department_en);
    setDes(item.department_des);
    setOther(item.other);
    if (item.status === 1) {
      setEnable(true);
      setDisable(false);
    } else {
      setEnable(false);
      setDisable(true);
    }
  };

  const getStatusContent = (status) => {
    switch (status) {
      case 1:
        return (
          <Button type="primary" ghost shape="round" icon={<CheckCircleOutlined />} style={mixedFont}>
            Enable
          </Button>
        );
      case 0:
        return (
          <Button type="primary" danger ghost shape="round" icon={<ClockCircleOutlined />} style={mixedFont}>
            Disable
          </Button>
        );
      default:
        return null;
    }
  };

  const onShowSizeChange = async (current) => {
    setPageNumber(current);
    const objTmp = { ...objFilter, page: current };
    setObjFilter(objTmp);
    await getList(objTmp);
  };

  const OnSearchText = (value) => {
    setCurrentPage(1);
    const objTmp = {
      ...objFilter,
      department_name: value.target.value,
      page: 1,
    };
    setObjFilter(objTmp);
    getList(objTmp);
  };

  const OnSearchTextDept = (value) => {
    const objTmp = {
      ...objFilter,
      department_name: value.target.value,
      page: 1,
    };
    getListDept(objTmp);
  };

  return (
    <div style={khmerFont}>
      <div className="sprinSave-container">
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      <div style={boxHeader}>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          {boxHeaderTagText("ការគ្រប់គ្រង់ ព័ត៌មានផ្នែក")}
          <Input style={{ width: 250, ...mixedFont }} placeholder="ស្វែងរក..." onChange={OnSearchText} allowClear />
        </div>
        <div>
          <Button disabled={!addvalue} onClick={onOpenNewDepartment} type="primary" icon={<PlusCircleOutlined />} style={mixedFont}>
            បន្ថែមផ្នែកថ្មី
          </Button>
        </div>
      </div>

      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <div className="hide-scrollbar" style={{ position: "relative", maxHeight: "calc(100vh - 270px)", overflowY: "auto", borderBottom: "1px solid #f0f0f0" }}>
            <Table className="rounded-table" style={{ margin: 0 }}>
              <thead style={{ position: "sticky", top: 0, zIndex: 100 }}>
                <tr className="table-success">
                <th style={{ ...khmerFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>#</th>
              
                <th style={{ ...khmerFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>ផ្នែក (ខ្មែរ)</th>
                <th style={{ ...englishFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>Department (English)</th>
                <th style={{ ...khmerFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>ស្ថិតក្រោម</th>
                <th style={{ ...khmerFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>កំរិត</th>
                <th style={{ ...mixedFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>ស្ថានភាព / Status</th>
                <th style={{ ...khmerFont, position: "sticky", top: 0, zIndex: 100, background: "#d1e7dd", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>សកម្មភាព</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, idx) => (
                <tr key={item.code || idx}>
                  <td style={khmerFont}>{itemsPerPage * (pageNumber - 1) + idx + 1}</td>
                  {/* <td style={khmerFont}>{getTageStyle("CODE:" + item.code)}</td> */}
                  <td style={khmerFont}>
                    <Tag color="blue" style={{padding: 4}}> <strong>
                      {item.department_name}
                    </strong></Tag>
                   
                    <div style={styles.staffContainer}>
                      {item.staff_list && item.staff_list.map((staff, index) => (
                        <Tooltip key={index} title={`${staff.fullname || staff.username}${staff.range_short ? ` (${staff.range_short})` : ''}`}>
                          <div style={styles.avatarWrapper}>
                            <Avatar 
                              src={staff.image ? `${linkPath}${staff.image}` : null}
                              icon={!staff.image && <UserOutlined />}
                              style={styles.staffAvatar}
                              size="medium"
                            >
                              {!staff.image && staff.fullname ? staff.fullname.charAt(0).toUpperCase() : null}
                            </Avatar>
                            <span style={styles.onlineDot}></span>
                          </div>
                        </Tooltip>
                      ))}
                    </div>
                  </td>
                  <td style={englishFont}>{item.department_en}</td>
                  <td style={khmerFont}>{item.parent_dept && <Tag color="magenta" style={khmerFont}>{item.parent_dept}</Tag>}</td>
                  <td style={khmerFont}>{item.level_no}</td>
                  <td style={mixedFont}>{getStatusContent(item.status)}</td>
                  <td style={{ width: 100 }}>
                    <Stack gap={1} direction="horizontal">
                      <Button type="primary" icon={<EditFilled />} disabled={!Editvalue} onClick={() => onOpenEditModel(item)} />
                      <Button icon={<DeleteFilled />} disabled={!deletevalue} onClick={() => onOpenModelDelete(item)} danger />
                    </Stack>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>
        )}
        <Pagination onChange={onShowSizeChange} defaultCurrent={currentPage} total={Total} style={{ marginTop: 16, textAlign: "center" }} />
      </div>

      {/* Add/Edit Modal */}
      <Modal
        title={!code ? "បង្កើតផ្នែកថ្មី" : "កែប្រែផ្នែក"}
        width={700}
        open={visableNewDepartment}
        onCancel={onCancel}
        footer={[
          <Button key="cancel" danger onClick={onCloseDepartment} style={mixedFont}>Cancel</Button>,
          <Button key="save" type="primary" onClick={onSaveDepartment} style={mixedFont}>{!code ? "Save" : "Update"}</Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={<span style={khmerFont}>លេខកូដផ្នែក</span>}>
              <Input value={code} onChange={onChangeCode} disabled={visableTextbox} style={khmerFont} />
            </Form.Item>
            <Form.Item label={<span style={khmerFont}>ឈ្មោះផ្នែក / ភាសាខ្មែរ</span>}>
              <Input.TextArea rows={2} value={department} onChange={onChangeDeparment} style={khmerFont} />
            </Form.Item>
            <Form.Item label={<span style={englishFont}>Department Name / English</span>}>
              <Input.TextArea rows={2} value={department_en} onChange={onChangeDeparment_en} style={englishFont} />
            </Form.Item>
            <Form.Item label={<span style={mixedFont}>ស្ថានភាព / Status</span>}>
              <Space>
                <Checkbox checked={enable} onChange={handleCheckboxChange_Enable} style={mixedFont}>Enable</Checkbox>
                <Checkbox checked={disable} onChange={handleCheckboxChange_Diable} style={mixedFont}>Disable</Checkbox>
              </Space>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={<span style={khmerFont}>ស្ថិតក្រោម</span>}>
              <Select
                showSearch allowClear placeholder="Select department"
                value={under_dept_id}
                onSearch={(val) => OnSearchTextDept({ target: { value: val } })}
                onChange={setUnderDepartment_id}
                style={khmerFont}
              >
                {listdepart.map(opt => (
                  <Option key={opt.code} value={opt.code} style={khmerFont}>{opt.department_name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label={<span style={khmerFont}>កំរិត</span>}>
              <InputNumber min={1} max={10} value={level_number} onChange={onChangeLevel_number} style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item label={<span style={khmerFont}>បរិយាយ</span>}>
              <Input.TextArea rows={3} value={des} onChange={onChageDes} style={khmerFont} />
            </Form.Item>
            <Form.Item label={<span style={khmerFont}>ផ្សេងៗ</span>}>
              <Input.TextArea rows={2} value={other} onChange={onChangeOther} style={khmerFont} />
            </Form.Item>
          </Col>
        </Row>
      </Modal>

      {/* Delete Department Modal */}
      <DeleteDepartmentModal
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        onConfirm={onClickDeleteYes}
        departmentName={deleteDepartmentData.departmentName}
        departmentCode={deleteDepartmentData.departmentCode}
        departmentId={deleteDepartmentData.departmentId}
        parentDept={deleteDepartmentData.parentDept}
        loading={loadingSpin}
      />
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    background: "#f5f5f5",
    minHeight: "calc(100vh - 200px)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    padding: "0 8px",
    flexWrap: "wrap",
    gap: 12,
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
  },
  stats: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  treeCard: {
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  treeContainer: {
    padding: "16px",
    maxHeight: "calc(100vh - 350px)",
    overflowY: "auto",
  },
  tree: {
    background: "transparent",
  },
  treeNodeTitle: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    padding: "8px 0",
    width: "100%",
    borderBottom: "1px solid #f0f0f0",
  },
  treeNodeIcon: {
    width: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  treeNodeInfo: {
    flex: 1,
    minWidth: 200,
  },
  treeNodeName: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
  },
  treeNodeEn: {
    fontSize: 12,
    color: "#666",
  },
  treeNodeMeta: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
    marginTop: 4,
  },
  metaTag: {
    fontSize: 10,
    margin: 0,
    padding: "0 6px",
    height: "auto",
    lineHeight: "18px",
  },
  treeNodeActions: {
    display: "flex",
    gap: 4,
    flexShrink: 0,
  },
  dotGreen: {
    width: 12,
    height: 12,
    borderRadius: 12,
    background: "#28a745",
    boxShadow: "0 0 6px rgba(40,167,69,0.7)",
    marginRight: 6,
  },
  dotYellow: {
    width: 12,
    height: 12,
    borderRadius: 12,
    background: "#f0ad4e",
    boxShadow: "0 0 6px rgba(240,173,78,0.8)",
    marginRight: 6,
  },
  dotGray: {
    width: 8,
    height: 8,
    borderRadius: 8,
    background: "#9e9e9e",
    marginRight: 8,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "400px",
  },
  modalContent: {
    padding: "8px 0",
  },
  formGroup: {
    marginBottom: 16,
  },
  staffContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    marginTop: 8,
  },
  staffAvatar: {
    border: "2px solid #fff",
    boxShadow: "0 0 4px rgba(0,0,0,0.2)",
    backgroundColor: "#1890ff",
  },
  avatarWrapper: {
    position: "relative",
    display: "inline-block",
  },
  onlineDot: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#52c41a",
    border: "2px solid #fff",
    zIndex: 1,
  },
  offlineDot: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#d9d9d9",
    border: "2px solid #fff",
    zIndex: 1,
  },
};

export default InformationDeptPage;